import classNames from 'classnames';
import { Plus } from 'lucide-react';
import { UDButton, UDText } from 'ud-ui/components';
import {
  type ButtonProps,
  type StyleProps,
  type TextProps,
  useCategoryContext,
} from 'ud-ui/components/category/hooks/use-category-list-context';
import { theme } from 'styles/theme/theme';

// Пропсы для EmptyList
export type EmptyListProps = {
  // Индивидуальные пропсы, перезаписывающие контекст
  textProps?: Partial<TextProps>;
  buttonProps?: Partial<ButtonProps>;
  styleProps?: Partial<StyleProps>;

  // Пропсы для кнопки
  onCreateClick?: () => void;
};

/**
 * Компонент для отображения пустого состояния списка
 */
function EmptyList({
  // Локальные пропсы для перезаписи контекста
  textProps: localTextProps,
  buttonProps: localButtonProps,
  styleProps: localStyleProps,

  onCreateClick: localOnCreateClick,
}: EmptyListProps) {
  // Получаем данные из контекста
  const context = useCategoryContext();

  // Объединяем данные из контекста с локальными пропсами
  const onCreateClick = localOnCreateClick || context.onCreateClick;

  const textProps = { ...context.textProps, ...localTextProps };
  const buttonProps = { ...context.buttonProps, ...localButtonProps };
  const styleProps = { ...context.styleProps, ...localStyleProps };

  // Компоненты для рендеринга
  const ButtonComponent = styleProps.buttonComponent || UDButton;

  return (
    <div className={classNames('flex-center flex-col my-auto', styleProps.containerClassName)}>
      {textProps.title && (
        <UDText style={{ fontWeight: 700 }} className={styleProps.textClassName} type="body-text">
          {textProps.title}
        </UDText>
      )}

      {textProps.subtitle && (
        <UDText className={styleProps.textClassName} type="subhead">
          {textProps.subtitle}
        </UDText>
      )}

      {onCreateClick && (
        <ButtonComponent
          className={classNames('flex-center', styleProps.buttonClassName)}
          onClick={onCreateClick}
          variant={buttonProps.variant || 'dark'}
        >
          {/* <UDIcon name="plus" componentProps={{ className: 'mr-2' }} /> */}
          <Plus size={16} className="mr-2" color={theme.colors.AccentNaplesYellow} />
          {buttonProps.text}
        </ButtonComponent>
      )}
    </div>
  );
}

export default EmptyList;
